import { render, staticRenderFns } from "./RecordingTimer.vue?vue&type=template&id=d2b7b1a0"
import script from "./RecordingTimer.vue?vue&type=script&lang=js"
export * from "./RecordingTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2b7b1a0')) {
      api.createRecord('d2b7b1a0', component.options)
    } else {
      api.reload('d2b7b1a0', component.options)
    }
    module.hot.accept("./RecordingTimer.vue?vue&type=template&id=d2b7b1a0", function () {
      api.rerender('d2b7b1a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/RecordingTimer.vue"
export default component.exports